import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29185dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__backdrop" }
const _hoisted_2 = { class: "modal__information" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Compra finalizada com sucesso!", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Você pode acompanhar seu pedido ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("aqui.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "modal__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }),
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: { name: 'profile'},
          class: "modal__link"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.modalAlertOpened]
  ])
}